import { useState } from 'react';
import { get_user_by_email_request_url, reminder_request_url } from '../Utilities/apiUrl';
import consts from '../Utilities/appConsts.json';
import useIframeParams from './useIframeParam';
import useLoader from './useLoader';


const useSendLink = () => {

    const [textLink, setTextLink] = useState<string>("");
    const [isSendLink, setIsSendLink] = useState(false);
    const [isMail, setIsMail] = useState(true)
    const [isShowHelperText, setIsShowHelperText] = useState(false)
    const [isAddActiveModal, setIsAddActiveModal] = useState(false);
    const channel = useIframeParams('channel') || "";
    const { loading, showLoading, hideLoading, LoaderComponent } = useLoader();

    const sendLink = async (mail: string) => {
        try {
            showLoading();
            const data = await fetch(`${get_user_by_email_request_url}&email=${mail}`);
            let response = await data.json();

            if (response.isValid) {
                if (response.payLoad === consts.RESPONSE_MOBILE_MAIL) {
                    setIsMail(false);
                }
                if (response.payLoad === consts.RESPONSE_MAIL) {
                    reminder(consts.EMAIL, mail)
                }
            } else {
                    if (response.errorCode == 546) {
                      setIsAddActiveModal(true)
                    }
                setIsShowHelperText(true);
            }

        } catch (error) {
            setIsShowHelperText(true);
        }
        finally {
            hideLoading();
        }

    };
    const reminder = async (source: string, mail: string) => {
        try {
            showLoading();
            const data = await fetch(`${reminder_request_url}&email=${mail}&provider=${source}&channel=${channel}`);
            const response = await data.json();
            hideLoading();
            if (response.isValid) {
                setIsSendLink(true);

                switch (source) {
                    case consts.MOBILE: 
                        const reversedPart = response.payLoad.slice(-4)// Reversing the first part
                        const resultText =  reversedPart + response.payLoad.slice(0, -4)
                        setTextLink(`שלחנו לך קישור למספר ${resultText} להגדרת סיסמה חדשה`);
                        break;
                    case consts.EMAIL: setTextLink("שלחנו לך קישור למייל להגדרת הסיסמה החדשה שלך");
                        break;
                    default:
                        // Handle other cases if needed
                        break;
                }
            } else {
                // Handle the case when data is not valid
            }
        } catch (error) {
            // Handle the error
        }
    };

    return { sendLink, reminder, textLink, isSendLink, isMail, isShowHelperText,setIsShowHelperText, setIsAddActiveModal, isAddActiveModal, loading, LoaderComponent };
};

export default useSendLink;